module.exports = __webpack_public_path__ + "img/earthbound.93e76c2c.png";